import React, { createContext, useContext, useEffect, useState } from "react";
import "./Loader.css";

export const LoaderContext = createContext({
    start: (loaderText) => {},
    stop: () => {},
    loaderText: "",
    isLoading: false,
});

export const LoaderProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [loaderText, setLoaderText] = useState("");
    const [loaderStack, setLoaderStack] = useState([]);

    const start = (loaderText = "Loading...") => {
        setLoaderText(loaderText);
        setLoaderStack([...loaderStack, true]);
    };

    const stop = () => setLoaderStack([...loaderStack.slice(1)]);

    useEffect(() => {
        if (!loaderStack.length) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
    }, [loaderStack, start, stop]);

    return (
        <LoaderContext.Provider
            value={{
                isLoading,
                start,
                stop,
                loaderText,
            }}
        >
            {children}
        </LoaderContext.Provider>
    );
};

export const useLoader = () => {
    const context = useContext(LoaderContext);

    return {
        start: context.start,
        stop: context.stop,
    };
};

export const Loader = () => {
    const { isLoading, loaderText } = useContext(LoaderContext);

    return <>{isLoading ? <div className="app-loader"><div className="spinner"/>{loaderText}</div> : null}</>;
};
